import { render, staticRenderFns } from "./resourceNiche.vue?vue&type=template&id=3fd96c96&scoped=true"
import script from "./resourceNiche.vue?vue&type=script&lang=js"
export * from "./resourceNiche.vue?vue&type=script&lang=js"
import style0 from "./resourceNiche.vue?vue&type=style&index=0&id=3fd96c96&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd96c96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fd96c96')) {
      api.createRecord('3fd96c96', component.options)
    } else {
      api.reload('3fd96c96', component.options)
    }
    module.hot.accept("./resourceNiche.vue?vue&type=template&id=3fd96c96&scoped=true", function () {
      api.rerender('3fd96c96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/resourceNiche.vue"
export default component.exports